var exports = {
  "kL": "x7be19a29--0c66a1--container",
  "DD": "x7be19a29--0c66a1--title",
  "Qq": "x7be19a29--0c66a1--text",
};

module.exports = exports;
